import React, { useState } from "react";
import { motion } from "framer-motion";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";
//10 Oct 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

const EtEternityCTA = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 09 Oct 2025 - Harmonizing different CTAs
  // Updated - 10 Oct 2025 - Refined for conversational interface
  // Updated - 25 Nov 2025 - Refined for Unified CTA - ctaSource

  // 1 -  Local UI state 
  // const [open, setOpen] = useState(false); // 10 Oct 2025

  const [open, setOpen] = useState({ visible: false, source: null }); // 25 Nov 2025 - unified CTA


  return (
    <section
      id="contact" // 09 Oct 2025 - changed from "get-started", 10 Oct 2025 - changed from "contact-cta"
      // className="py-20 bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 text-white text-center relative"
      className="py-20 bg-gradient-to-b from-orange-700 via-orange-600 to-black text-white text-center relative"
      // className="py-20 bg-gradient-to-b from-black via-orange-600 to-black text-white text-center relative"
    >
      {/* Overlay texture */}
      <div className="absolute inset-0 opacity-80 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      {/* Animated glow pulse */}
      {/* <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 via-orange-400/20 to-transparent mix-blend-overlay animate-[pulse_10s_ease-in-out_infinite]" /> */}

      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-600 to-black animate-[pulse_15s_ease-in-out_infinite]" />

      <motion.div
        className="relative z-10 max-w-3xl mx-auto px-4"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Headline */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Ignite Your Growth Journey?
          {/* Your Growth Starts with a Conversation. */}
        </h2>

        {/* Subtext */}
        {/* <p className="text-lg text-orange-100 mb-8">
          Partner with Eternity to align vision, empower leaders, and unlock
          exponential performance. Let’s build your growth engine together.
        </p>
        <p className="text-lg text-orange-100 mb-8">
          Let’s start a conversation on how Eternity can help align vision,
          empower leaders, and unlock exponential performance.
        </p>
        <p className="text-lg text-orange-100 mb-8">
          Every transformation begins with a dialogue. Let’s explore how your next
          growth curve can take shape with Eternity.
        </p> */}
        <p className="text-lg text-orange-100 mb-8">
         Start a conversation with us to design your growth engine —
          powered by <strong>clarity, rhythm, and AI-driven</strong> execution.
        </p>

        {/* CTA Button */}
        <motion.a
          // href="#contact"
          // onClick={() => setOpen(true)}
          onClick={() => setOpen({ visible: true, source: "eternity-home-cta" })} // 25 Nov 2025
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition cursor-pointer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <RocketLaunchIcon className="h-6 w-6" />
          {/* Let’s Talk */}
          Start the Conversation
        </motion.a>
        {/* {open && <EtModalContactConversation open={open} onClose={() => setOpen(false)} />} */} 
        {/* 25 Nov 2025 */}
        {open?.visible && (
          <EtModalContactConversation
            open={open}                   // full object with source
            onClose={() => setOpen({ visible: false, source: null })} // reset
          />
        )}
      </motion.div>
    </section>
  );
};

export default EtEternityCTA;